<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.昵称')" prop="userName">
                <a-input v-model="queryParam.userName" @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('用户.昵称')" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.邮箱')" prop="email">
                <a-input v-model="queryParam.email" :placeholder="$t('通用.输入.请输入')+$t('用户.邮箱')" allow-clear/>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('系统用户.开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                               :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('系统用户.结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                               :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('通用.按钮.收起') : $t('通用.按钮.展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleManualScore" v-hasPermi="['user:bill:manualOperateScore']">
          <a-icon type="plus-circle" />{{$t('用户积分变动记录.手动操作积分')}}
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:log:export']">-->
<!--          <a-icon type="download" />{{$t('通用.按钮.导出')}}-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="multiple"  @click="handleSelectExport" v-hasPermi="['user:log:export']">-->
<!--          <a-icon type="download" />{{$t('通用.按钮.选中导出')}}-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="changeMoney" slot-scope="text, record">
          {{ record.sign+''+record.changeMoney }}
        </span>

        <span slot="type" slot-scope="text, record">
             <custom-dict-tag :options="customDict.BillTypeEnum" :value="record.type"/>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    
    <!-- 手动操作积分对话框 -->
    <a-modal
      :title="$t('用户积分变动记录.手动操作积分')"
      :visible="manualScoreVisible"
      :okText="$t('通用.按钮.确定')"
      :cancelText="$t('通用.按钮.关闭')"
      @ok="handleManualScoreConfirm"
      @cancel="handleManualScoreCancel"
      :confirmLoading="manualScoreLoading"
    >
      <a-form :form="manualScoreForm">
        <a-form-item :label="$t('用户积分变动记录.选择用户')">
          <a-select
            v-decorator="[
              'userId',
              { rules: [{ required: true, message: $t('用户积分变动记录.请选择用户') }] }
            ]"
            :placeholder="$t('用户积分变动记录.请选择用户')"
            show-search
            :filter-option="filterUserOption"
            @search="handleUserSearch"
            @change="handleUserChange"
          >
            <a-select-option v-for="user in userList" :key="user.id" :value="user.id">
              {{ user.nickName }} ({{ user.mobile }})
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('用户积分变动记录.操作类型')">
          <a-radio-group v-decorator="['billType', { rules: [{ required: true, message: '请选择操作类型' }],initialValue: '1' }]" default-value="1">
            <a-radio value="1">{{$t('用户积分变动记录.增加积分')}}</a-radio>
            <a-radio value="2">{{$t('用户积分变动记录.减少积分')}}</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="$t('用户积分变动记录.积分数量')">
          <a-input-number
            v-decorator="[
              'score',
              { rules: [{ required: true, message: $t('用户积分变动记录.积分数量') }, { type: 'number', min: 1, message: '积分数量必须大于0' }] }
            ]"
            :placeholder="$t('用户积分变动记录.请输入积分数量')"
            :min="1"
            style="width: 100%"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageLog,listLog, delLog, manualOperateScore } from '@/api/user/log'
import { pageUser } from '@/api/user/user'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Log',
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        orderId: undefined,
        userId: undefined,
        userName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        type: undefined,
        fundType: undefined,
        descr: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: this.getTableColumns(),
      // 手动操作积分相关数据
      manualScoreVisible: false,
      manualScoreLoading: false,
      manualScoreForm: this.$form.createForm(this),
      userList: [],
    }
  },
  filters: {
  },
  created () {
    this.getScoreRouteList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    $route:'getScoreRouteList',
    '$i18n.locale'() {
      // 语言变化时重新设置columns
      this.columns =  this.getTableColumns();
      this.getList();
    }

  },
  mounted() {

  },
  methods: {
    getTableColumns() {
      return [
        // {
        //   title: this.$t('用户积分变动记录.订单编号'),
        //   dataIndex: 'orderId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('用户.昵称'),
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.手机号'),
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户积分变动记录.变动的积分数'),
          dataIndex: 'changeMoney',
          scopedSlots: { customRender: 'changeMoney' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户积分变动记录.变动前剩余积分'),
          dataIndex: 'beforeMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户积分变动记录.变动后剩余积分'),
          dataIndex: 'afterMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户积分变动记录.备注'),
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          align: 'center'
        },
        {
          title: this.$t('通用.文本.创建时间'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
      ]
    },

    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },

    getScoreRouteList() {
      let params = this.$route.params;
      if (params.userId) {
        this.queryParam.userId = params.userId
      }
      this.getList()
    },

    /** 查询用户积分变动记录列表 */
    getList () {
      this.loading = true
      this.queryParam.fundType=50
     pageLog(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        orderId: undefined,
        userId: undefined,
        userName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        type: undefined,
        fundType: undefined,
        descr: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delLog(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('user/log/export',
            that.queryParam
          , `用户积分变动记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出选中数据'),
        onOk () {
          that.download('user/log/export', queryParam, `用户积分变动记录_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        }
      })
    },
    // 手动操作积分相关方法
    handleManualScore() {
      this.manualScoreVisible = true;
      this.getUserList();
    },
    handleManualScoreConfirm() {
      this.manualScoreForm.validateFields((err, values) => {
        if (!err) {
          this.manualScoreLoading = true;
          const data = {
            userId: values.userId,
            billType: values.billType,
            changeMoney: values.score
          };
          manualOperateScore(data).then(response => {
            this.$message.success('success');
            this.manualScoreVisible = false;
            this.manualScoreForm.resetFields();
            this.getList();
          }).catch(error => {
            this.$message.error(error.message || 'fail');
          }).finally(() => {
            this.manualScoreLoading = false;
          });
        }
      });
    },
    handleManualScoreCancel() {
      this.manualScoreVisible = false;
      this.manualScoreForm.resetFields();
    },
    getUserList() {
      const params = {
        pageNum: 1,
        pageSize: 1000000
      };
      pageUser(params).then(response => {
        this.userList = response.data || [];
      });
    },
    filterUserOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleUserSearch(value) {
      this.getUserList();
    },
    handleUserChange(value) {
      console.log('选择用户:', value);
    }
  }
}
</script>
